import { render } from "./HeroSectionEditor.vue?vue&type=template&id=1333a44f"
import script from "./HeroSectionEditor.vue?vue&type=script&lang=js"
export * from "./HeroSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__